import PageNav from "../../Components/PageNav";
import Dashboard from "../../Components/Dashboard";
import useNewDataFetcher from "../../Hooks/newUseDataFetcher";
import "./style.scss";

function DirectorOfRecruiting() {
  const { data: apiData, isReady } = useNewDataFetcher({ endPoint: "/api/v1/dashboard/recruiting" });
  let { json, data } = apiData || { json: [], data: [] };
  return (
    <>
      <PageNav title="Director of Recruiting" />
      <Dashboard json={json} data={data} isReady={isReady} />
    </>
  );
}

export default DirectorOfRecruiting;
